package com.rainbowclubs.rainbow.domain.use_cases.club

import com.rainbowclubs.rainbow.data.models.Club
import com.rainbowclubs.rainbow.data.requests.UpdateClubRequest
import com.rainbowclubs.rainbow.domain.repositories.ClubImageUpload
import com.rainbowclubs.rainbow.domain.repositories.ClubRepository

class UpdateClubUseCase(
    private val clubRepository: ClubRepository,
) {
    suspend operator fun invoke(
        clubId: String,
        request: UpdateClubRequest,
        image: ClubImageUpload? = null,
    ): Result<Club> {
        return clubRepository.updateClub(
            clubId = clubId,
            request = request,
            image = image,
        )
    }
}
